import React from 'react';
import { Button } from './Button';
import { Modal, ModalHeader, ModalTitle, ModalContent, ModalFooter } from './Modal';
import { ExclamationTriangleIcon, CheckCircleIcon, InfoIcon, XCircleIcon } from './Icons';

const AlertDialog = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'info', // 'info', 'success', 'warning', 'error'
  confirmText = 'OK',
  showCancel = false,
  cancelText = 'Cancel',
  onConfirm,
  isLoading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    const iconClass = "h-6 w-6";
    switch (type) {
      case 'success':
        return <CheckCircleIcon className={`${iconClass} text-green-500`} />;
      case 'warning':
        return <ExclamationTriangleIcon className={`${iconClass} text-yellow-500`} />;
      case 'error':
        return <XCircleIcon className={`${iconClass} text-red-500`} />;
      default:
        return <InfoIcon className={`${iconClass} text-blue-500`} />;
    }
  };

  const getTitle = () => {
    if (title) return title;
    switch (type) {
      case 'success':
        return 'Success';
      case 'warning':
        return 'Warning';
      case 'error':
        return 'Error';
      default:
        return 'Information';
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalHeader>
        <ModalTitle className="flex items-center gap-2">
          {getIcon()}
          {getTitle()}
        </ModalTitle>
      </ModalHeader>
      <ModalContent>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {message}
        </p>
      </ModalContent>
      <ModalFooter>
        <div className="flex items-center justify-end gap-3">
          {showCancel && (
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText}
            </Button>
          )}
          <Button
            variant={type === 'error' ? 'destructive' : 'default'}
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : confirmText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AlertDialog;

